import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

const ServiceStruct = () => {
  return (
    <section className="py-5 service-section">
      <Container style={{ maxWidth: "80%", margin: "0 auto" }}>
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
            <motion.img
              src={require("../../static/media/service/service1.webp")}
              alt="Cableado estructurado y mantenimiento de redes"
              className="img-fluid service-img"
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            />
          </Col>

          <Col xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <h2 className="fw-bold service-title mb-4">
                Desarrollo de software y páginas web
              </h2>
              <p className="service-text">
                Diseñamos e implementamos software a medida, así como páginas web modernas, 
                funcionales y seguras. Nos enfocamos en soluciones escalables que apoyen la 
                transformación digital de nuestros clientes y fortalezcan su presencia en línea.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>

      <style>
        {`
          .service-section {
            background: linear-gradient(90deg, #333 0%, #000 50%, #333 100%);
          }
          .service-section .service-title {
            font-size: 1.2rem;
            color: #fff;
            margin-bottom: 0.3rem;
          }
          .service-section .service-text {
            font-size: 0.8rem;
            line-height: 1.7;
            color: #f8f9fa;
            text-align: justify;
            margin-bottom: 1rem;
          }
          .service-section .service-img {
            border-radius: 12px;
            max-width: 90%;
            height: auto;
            background-color: #fff;
            padding: 8px;
          }

          @media (min-width: 576px) {
            .service-section .service-title {
              font-size: 1.5rem !important;
            }
            .service-section .service-text {
              font-size: 0.9rem !important;
            }
          }

          @media (min-width: 992px) {
            .service-section .service-title {
              font-size: 2rem !important;
            }
            .service-section .service-text {
              font-size: 1rem !important;
            }
            .service-section .service-img {
              max-width: 70% !important;
            }
          }

          @media (max-width: 576px) {
            .service-section .service-img {
              max-width: 80% !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default ServiceStruct;
